import { render, staticRenderFns } from "./on_enclosure.vue?vue&type=template&id=2febca13"
import script from "./on_enclosure.vue?vue&type=script&lang=js"
export * from "./on_enclosure.vue?vue&type=script&lang=js"
import style0 from "./on_enclosure.vue?vue&type=style&index=0&id=2febca13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports